import { Spinner } from '@/components/spinner'
import { FC, memo } from 'react'

export const SuspenseFallback: FC = memo(() => {
  return (
    <div className="flex h-[90vh] w-full items-center justify-center">
      <Spinner size="md" />
    </div>
  )
})
